import { notificationService } from "../components/Notifications/NotificationManager";
import { toast } from "react-toastify";
import React from "react";

class ModernMessageService {
  constructor() {
    this.lastMessage = null;
    this.lastMessageTime = 0;
  }

  _shouldSkipMessage(message) {
    const now = Date.now();
    if (this.lastMessage === message && now - this.lastMessageTime < 1000) {
      return true;
    }
    this.lastMessage = message;
    this.lastMessageTime = now;
    return false;
  }

  successMessage(message, customConfig = {}) {
    if (this._shouldSkipMessage(message)) return;

    console.log("Notificação de sucesso:", message);
    return notificationService.success(message, {
      duration: 5000,
      pauseOnHover: true,
      ...customConfig,
    });
  }

  infoMessage(message, customConfig = {}) {
    console.log("Notificação de info:", message);
    return notificationService.info(message, {
      duration: 4000,
      pauseOnHover: true,
      ...customConfig,
    });
  }

  warningMessage(message, customConfig = {}) {
    console.log("Notificação de aviso:", message);
    return notificationService.warning(message, {
      duration: 6000,
      pauseOnHover: true,
      ...customConfig,
    });
  }

  quickSuccessMessage(message, customConfig = {}) {
    console.log("Notificação rápida:", message);
    return notificationService.success(message, {
      duration: 3000,
      pauseOnHover: false,
      ...customConfig,
    });
  }

  errorMessage(message, customConfig = {}) {
    console.log(" Notificação de erro:", message);
    return notificationService.error(message, {
      duration: 7000,
      pauseOnHover: true,
      ...customConfig,
    });
  }

  importantSuccessMessage(message, customConfig = {}) {
    console.log("Notificação importante:", message);
    return notificationService.important(message, {
      title: "Salvo com Sucesso!",
      duration: 6000,
      pauseOnHover: true,
      ...customConfig,
    });
  }

  updateToast(toastId, options = {}) {
    if (!toastId) {
      console.warn("updateToast chamado sem toastId");
      return;
    }

    if (typeof toastId === "string" || typeof toastId === "number") {
      try {
        this.dismiss(toastId);

        let message = "";
        let type = "info";

        if (
          options.render &&
          options.render.props &&
          options.render.props.texto
        ) {
          message = options.render.props.texto;
        }
        else if (typeof options.render === "string") {
          message = options.render;
        }
        else if (options.render && typeof options.render === "object") {
          message = "Operação em andamento...";
        }
        else {
          message = "Operação em andamento...";
        }

        if (options.type === "error" || message.toLowerCase().includes("erro")) {
          type = "error";
        } else if (message.toLowerCase().includes("sucesso") || message.toLowerCase().includes("concluído")) {
          type = "success";
        } else if (message.toLowerCase().includes("aviso") || message.toLowerCase().includes("atenção")) {
          type = "warning";
        }

        const duration = options.autoClose
          ? options.autoClose === true
            ? 4000
            : options.autoClose
          : 4000;

        if (type === "error") {
          return notificationService.error(message, {
            duration,
            pauseOnHover: true,
            ...options,
          });
        } else if (type === "success") {
          return notificationService.success(message, {
            duration,
            pauseOnHover: true,
            ...options,
          });
        } else if (type === "warning") {
          return notificationService.warning(message, {
            duration,
            pauseOnHover: true,
            ...options,
          });
        } else {
          return notificationService.info(message, {
            duration,
            pauseOnHover: true,
            ...options,
          });
        }
      } catch (error) {
        console.warn("Erro ao atualizar toast:", error);
      }
    }

    console.warn("updateToast: toastId inválido ou opções não suportadas");
  }

  updateProgress() {
    console.warn("updateProgress não implementado no novo sistema");
  }

  dismissAll() {
    notificationService.clear();
  }

  dismiss(id) {
    if (id) {
      notificationService.remove(id);
    }
  }

  testMessage(message = "🧪 Teste de notificação moderna") {
    console.log("Criando notificação de teste...");
    return this.successMessage(message, {
      title: "Teste do Sistema",
      duration: 5000,
    });
  }

  debugMessage(message = "🔍 Debug - Sistema Moderno Funcionando") {
    console.log("🔍 Debug - Sistema moderno ativo");
    return notificationService.add({
      type: "info",
      title: "🔍 Debug Mode",
      message,
      duration: 0, 
      pauseOnHover: false,
    });
  }

  confirmMessage = (message, title = 'Confirmação') => {
    return new Promise((resolve) => {
      const toastId = toast(
        <div style={{ padding: '10px' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '14px', color: '#333333' }}>
            {title}
          </div>
          <div style={{ marginBottom: '12px', fontSize: '13px', whiteSpace: 'pre-line', color: '#333333' }}>
            {message}
          </div>
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <button
              style={{
                padding: '6px 12px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px'
              }}
              onClick={() => {
                toast.dismiss(toastId);
                resolve(false);
              }}
            >
              Cancelar
            </button>
            <button
              style={{
                padding: '6px 12px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px'
              }}
              onClick={() => {
                toast.dismiss(toastId);
                resolve(true);
              }}
            >
              Confirmar
            </button>
          </div>
        </div>,
        {
          position: "top-center",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
    });
  }
}

const instance = new ModernMessageService();

export default instance;
